import { PayloadAction } from '@reduxjs/toolkit';
import { BuildElementIdParams } from '@ui/features/quote-builder/state/utilities/element-id';
import { clearRawFieldValue } from '@ui/features/quote-builder/state/utilities/raw-field-values';
import { QuoteBuilderStateType } from '@ui/features/quote-builder/types/state';
import { WritableDraft } from 'immer';

export function rawFieldValueCleared(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<BuildElementIdParams>,
) {
  clearRawFieldValue(state, action.payload);
}
